import { Icon } from '@advanza/ui'
import clsx from 'clsx'
import { ChangeEventHandler } from 'react'

interface Props {
    isSelected: boolean
    select: ChangeEventHandler<HTMLInputElement>
    disabled?: boolean
    ariaLabel?: string
}

const FOCUS_RING =
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#5a8bfc]'

const ListItemSelector = ({ isSelected, select, disabled, ariaLabel }: Props) => {
    return (
        <>
            <label className={clsx(isSelected && 'checked', 'clickable')}>
                <Icon
                    primColor={isSelected && !disabled}
                    grey={disabled}
                    name={isSelected ? 'check_box' : 'check_box_outline_blank'}
                />
                <input
                    type="checkbox"
                    name="item"
                    aria-label={ariaLabel}
                    className={FOCUS_RING}
                    onChange={select}
                    checked={isSelected}
                    disabled={disabled}
                />
            </label>
        </>
    )
}

export default ListItemSelector
